import React, { useState, useEffect } from 'react';

const FloatingContactToggle = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  useEffect(() => {
    // Show the button after a delay
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const toggleForm = () => {
    setIsOpen(!isOpen);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleWhatsAppMessage = (e) => {
    e.preventDefault();
    const phoneNumber = "9927042135";
    const message = `Hello! I would like to get in touch with AIM Journal of Homoeopathic Medicine.

Name: ${formData.name}
Email: ${formData.email}
Message: ${formData.message}`;
    
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
    setIsOpen(false);
    
    // Reset form
    setFormData({
      name: '',
      email: '',
      message: ''
    });
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Floating Toggle Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <button
          onClick={toggleForm}
          className="group relative w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full shadow-2xl hover:shadow-blue-500/25 transition-all duration-300 transform hover:scale-110 active:scale-95"
        >
          {/* Animated Ring */}
          <div className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 opacity-30" style={{
            animation: 'ping 3s cubic-bezier(0, 0, 0.2, 1) infinite'
          }}></div>
          
          {/* Button Content */}
          <div className="relative flex items-center justify-center w-full h-full">
            <i className={`bi ${isOpen ? 'bi-x-lg' : 'bi-chat-dots'} text-white text-xl transition-transform duration-300 group-hover:scale-110`}></i>
          </div>
          
          {/* Floating Text */}
          <div className="absolute right-full mr-4 top-1/2 transform -translate-y-1/2 bg-black/80 text-white px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            {isOpen ? 'Close' : 'Send us a Message'}
            <div className="absolute left-full top-1/2 transform -translate-y-1/2 w-0 h-0 border-l-4 border-l-black/80 border-t-4 border-t-transparent border-b-4 border-b-transparent"></div>
          </div>
        </button>
      </div>

      {/* Contact Form Modal */}
      {isOpen && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 transform transition-all duration-300 scale-100">
            {/* Header */}
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl flex items-center justify-center">
                  <i className="bi bi-chat-dots text-white text-lg"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800">Send us a Message</h3>
                  <p className="text-gray-500 text-sm">We'd love to hear from you</p>
                </div>
              </div>
              <button
                onClick={() => setIsOpen(false)}
                className="w-8 h-8 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors duration-200"
              >
                <i className="bi bi-x text-gray-600"></i>
              </button>
            </div>

            {/* Contact Form */}
            <form onSubmit={handleWhatsAppMessage} className="space-y-4">
              <div>
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 text-gray-800 placeholder-gray-500 focus:border-blue-400 focus:ring-2 focus:ring-blue-400/20 transition-all duration-200"
                />
              </div>
              <div>
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 text-gray-800 placeholder-gray-500 focus:border-blue-400 focus:ring-2 focus:ring-blue-400/20 transition-all duration-200"
                />
              </div>
              <div>
                <textarea
                  name="message"
                  placeholder="Your Message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows={4}
                  required
                  className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 text-gray-800 placeholder-gray-500 focus:border-blue-400 focus:ring-2 focus:ring-blue-400/20 transition-all duration-200 resize-none"
                />
              </div>
              <button
                type="submit"
                className="w-full btn-solid btn-solid-md"
              >
                <span className="flex items-center justify-center space-x-2">
                  <i className="bi bi-whatsapp"></i>
                  <span>Send WhatsApp Message</span>
                </span>
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default FloatingContactToggle;
